import "./about.css";

import React from "react";

import { ABOUT } from "../../data/content";
import PageHero from "../general/PageHero";
import PageMeta from "../general/PageMeta";

//"WHY GRAYLAG & CO" - photo and text side by side, alternating sides
const About = () => {
  return (
    <React.Fragment>
      <PageMeta title={"About"} />
      <PageHero />

      <h1 className={"section-title about-title"}>{ABOUT.TITLE}</h1>

      {ABOUT.SECTIONS.map((section, i) => (
        <section
          key={section.TITLE}
          className={`about-row ${i % 2 === 1 ? "is-reversed" : ""}`}
        >
          <div className={"about-photo"}>
            <img
              src={section.PHOTO.md}
              srcSet={section.PHOTO.srcSet}
              sizes={"(max-width: 800px) 100vw, 50vw"}
              alt={section.PHOTO.alt}
              width={section.PHOTO.width}
              height={section.PHOTO.height}
              loading={"lazy"}
            />
          </div>
          <div className={"about-text"}>
            <h2 className={"section-title"}>{section.TITLE}</h2>
            <p className={"body-text"}>{section.TEXT}</p>
          </div>
        </section>
      ))}
    </React.Fragment>
  );
};

export default About;
